// extracted by mini-css-extract-plugin
export default {"controls":"controls-module__controls___GGAHq","controls_body_ain__text":"controls-module__controls_body_ain__text___d1r4T"};